import React, { useState } from "react";
import Profile from "./profile/Profile";
// import Notifications from "./Notifications";
import Setting, { hasAnySettingsPermission } from "./Setting";
import { FaExpand, FaCompress } from "react-icons/fa";
import { Button } from "@nextui-org/react";
import InvestmentNotificationIcon from "./NotificationComponent";

const TopNav = ({ hamClick, setHamClick }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen().catch((err) => { });
    } else {
      // Exit fullscreen mode
      document.exitFullscreen().catch((err) => { });
    }
    setIsFullscreen(!isFullscreen);
  };

  const handleHamburgerClick = () => {
    setHamClick((prev) => !prev);
  };

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return "Good Morning";
    } else if (currentHour < 18) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };

  return (
    <div
      className={`h-[55px] z-[49] flex absolute !duration-200 !right-0 !shadow items-end rounded-none m-0 ${hamClick ? "w-[calc(100%_-_70px)]" : "w-[calc(100%_-_250px)]"
        }  `}
    >
      <div className="flex justify-between h-full w-full items-center pr-5">
        <div className="flex gap-5">
          {/* Hamburger Icon */}
          <div>
            <div
              className="hambar flex justify-center cursor-pointer ml-5 relative h-[25px] w-[26px] items-start flex-col gap-[.22rem]"
              onClick={handleHamburgerClick}
            >
              <div
                className={`duration-100 rounded-[2px] bg-[#D62328] dark:bg-slate-300 ${hamClick
                    ? "w-[25px] h-[.2rem] rotate-45 absolute bottom-3 -left-1"
                    : "w-[27px] h-[.23rem]"
                  }`}
              ></div>
              <div
                className={`h-[.23rem] duration-100 rounded-[2px] bg-[#D62328] dark:bg-slate-300 ${hamClick ? "hidden" : "w-[13px]"
                  }`}
              ></div>
              <div
                className={`duration-100 rounded-[2px] bg-[#D62328] dark:bg-slate-300 ${hamClick
                    ? "w-[25px] h-[.2rem] -rotate-45 absolute bottom-3 -left-1"
                    : "w-[18px] h-[.23rem]"
                  }`}
              ></div>
            </div>
          </div>
          <div className="font-medium ml-2 hidden md:block">
            Hello Admin, {getGreeting()}
          </div>
        </div>
        <div className="max-w-[400px] flex gap-6 items-center justify-center">
          <div className="max-w-[400px] flex gap-2 items-center justify-center">
            <InvestmentNotificationIcon />
            <Button
              isIconOnly
              size="sm"
              className={`bg-transparent hover:bg-gray-200 ${isFullscreen ? "bg-gray-200" : ""
                } `}
              radius="full"
              aria-label="Notifications"
              title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
              onClick={toggleFullscreen}
            >
              {isFullscreen ? (
                <FaCompress
                  size={20}
                  className="text-2xl scale-95 text-black/70"
                />
              ) : (
                <FaExpand
                  size={20}
                  className="text-2xl scale-95 text-black/70"
                />
              )}
            </Button>
            {hasAnySettingsPermission() && <Setting />}
          </div>
          <Profile />
        </div>
      </div>
    </div>
  );
};

export default TopNav;
